import React from 'react';
import PropTypes from 'prop-types';
import DropDownActionsMenu from 'components/field/DropDownActionsMenu/DropDownActionsMenu';
import EditAction from 'components/field/DropDownActionsMenu/EditAction';
import FieldTitle from 'components/aor/FieldTitle';
import HeaderColumn from 'components/ui/table/HeaderColumn';
import NoResults from 'components/form/styling/NoResults';
import Table from 'components/ui/table/Table';
import TableBodyCell from 'components/table/TableBodyCell';
import TableRow from 'components/ui/table/TableRow';
import TextField from 'components/show/TextField';
import utils from 'helpers/utils';

const ProductAccessPointsList = (props) => {
    const {
        accessPoints,
        productId,
        resource,
    } = props;

    if (utils.isEmpty(accessPoints)) {
        return <NoResults label='resources.access_points.no_results' />;
    }

    return (
        <Table responsive='scroll'>
            <TableRow>
                <HeaderColumn style={ { width: '90%' } } >
                    <FieldTitle
                        label='resources.access_points.fields.title'
                        source='title'
                        resource={ resource }
                    />
                </HeaderColumn>
                <HeaderColumn style={ { width: '10%' } }>&nbsp;</HeaderColumn>
            </TableRow>

            { utils.map(accessPoints, (accessPoint) => {
                if (!accessPoint) {
                    return null;
                }

                return (
                    <TableRow key={ `access-point-${ accessPoint.id }` } >
                        <TableBodyCell
                            field={ <TextField value={ accessPoint.title } /> }
                            link={ `${ resource }/${ accessPoint.id }/show` }
                            record={ { id: productId } }
                            resource='products'
                            source='title'
                        />

                        <TableBodyCell
                            field={
                                <DropDownActionsMenu>
                                    <EditAction url={ `/products/${ productId }/${ resource }/${ accessPoint.id }` } />
                                </DropDownActionsMenu>
                            }
                            record={ accessPoint }
                            resource={ resource }
                        />
                    </TableRow>
                );
            })

            }
        </Table>
    );
};

ProductAccessPointsList.propTypes = {
    accessPoints: PropTypes.object.isRequired,
    productId: PropTypes.string.isRequired,
    resource: PropTypes.string.isRequired,
};

export default ProductAccessPointsList;


// WEBPACK FOOTER //
// ./src/pages/products/productAccessPoints/ProductAccessPointsList.js